/* ================================================================
   Doja Cookies — theme.js
   Drawer / menu toggles, size pill selection, qty stepper,
   product card quick-add. The delivery picker has its own JS
   in delivery-picker.js.
================================================================ */
(function () {
  'use strict';

  const overlay = document.querySelector('[data-drawer-overlay]');
  const cartDrawer = document.getElementById('cart-drawer');
  const menuDrawer = document.getElementById('menu-drawer');
  // The drawer is a modal dialog, so aria-hidden has to track its open state and focus
  // has to move into it and back out. Without this the drawer was permanently
  // aria-hidden="true" and a screen-reader user could never reach the checkout button.
  let cartLastFocused = null;
  function openCart() {
    if (!cartDrawer) return;
    cartLastFocused = document.activeElement;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('open');
    document.body.classList.add('no-scroll');
    pulseCartCount();
    cartDrawer.querySelector('.cart-drawer__close')?.focus();
  }
  function closeCart() {
    const wasOpen = cartDrawer && cartDrawer.classList.contains('open');
    if (cartDrawer) {
      cartDrawer.classList.remove('open');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
    overlay && overlay.classList.remove('open');
    document.body.classList.remove('no-scroll');
    // Only pull focus back if we actually closed something — Escape fires closeCart()
    // unconditionally, and stealing focus on every keypress would be worse than useless.
    if (wasOpen && cartLastFocused && typeof cartLastFocused.focus === 'function') {
      cartLastFocused.focus();
    }
    cartLastFocused = null;
  }
  function openMenu() {
    if (!menuDrawer) return;
    menuDrawer.classList.add('open');
    document.querySelector('.menu-overlay')?.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeMenu() {
    menuDrawer && menuDrawer.classList.remove('open');
    document.querySelector('.menu-overlay')?.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }
  window.dojaOpenCart = openCart;
  window.dojaCloseCart = closeCart;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-cart"]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-action="close-cart"]')) { e.preventDefault(); closeCart(); }
    if (e.target.closest('[data-action="open-menu"]')) { e.preventDefault(); openMenu(); }
    if (e.target.closest('[data-action="close-menu"]')) { e.preventDefault(); closeMenu(); }
    if (e.target === overlay) closeCart();
    if (e.target.closest('.menu-overlay')) closeMenu();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); closeMenu(); } });

  function pulseCartCount() {
    document.querySelectorAll('.cart-count').forEach((el) => {
      el.classList.remove('pulse');
      void el.offsetWidth;
      el.classList.add('pulse');
      setTimeout(() => el.classList.remove('pulse'), 700);
    });
  }

  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.size-pill, .pdp-size');
    if (!pill || pill.disabled) return;
    e.preventDefault(); e.stopPropagation();
    const group = pill.closest('.card-sizes, .pdp-sizes');
    if (!group) return;
    group.querySelectorAll('.size-pill, .pdp-size').forEach((p) => p.classList.remove('selected'));
    pill.classList.add('selected');
    const variantId = pill.getAttribute('data-variant-id');
    if (variantId) {
      group.dispatchEvent(new CustomEvent('doja:variant-change', {
        bubbles: true,
        detail: { variantId, price: pill.getAttribute('data-variant-price'), label: pill.querySelector('.label')?.textContent || pill.textContent }
      }));
    }
  });

  document.addEventListener('doja:variant-change', (e) => {
    const pdpRoot = e.target.closest('.pdp-info, .product');
    if (pdpRoot) {
      const priceEl = pdpRoot.querySelector('[data-product-price]');
      const ctaEl   = pdpRoot.querySelector('[data-product-cta]');
      const variantInput = pdpRoot.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = e.detail.variantId;
      if (priceEl && e.detail.price) priceEl.textContent = formatMoney(parseInt(e.detail.price, 10));
      if (ctaEl && e.detail.price) {
        const labelSpan = ctaEl.querySelector('[data-cta-label]') || ctaEl;
        labelSpan.textContent = 'Add to bag · ' + formatMoney(parseInt(e.detail.price, 10));
      }
      return;
    }
    const cardRoot = e.target.closest('.card');
    if (cardRoot && e.detail.price) {
      const cardPrice = cardRoot.querySelector('.card-price');
      if (cardPrice) cardPrice.textContent = formatMoney(parseInt(e.detail.price, 10));
    }
  });

  function formatMoney(cents) {
    if (window.shopMoneyFormat) {
      const value = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return window.shopMoneyFormat.replace(/\{\{\s*amount.*?\}\}/, value);
    }
    return 'LE ' + (cents / 100).toFixed(0);
  }
  window.dojaFormatMoney = formatMoney;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty button');
    if (!btn) return;
    e.preventDefault();
    const wrap = btn.parentElement;
    const input = wrap.querySelector('input[type="number"]');
    const span  = wrap.querySelector('span');
    const isUp  = btn.getAttribute('data-step') === '+' || btn.textContent.trim() === '+';
    if (input) {
      let v = parseInt(input.value, 10) || 1;
      v = Math.max(1, v + (isUp ? 1 : -1));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (span) {
      let v = parseInt(span.textContent, 10) || 1;
      v = Math.max(1, v + (isUp ? 1 : -1));
      span.textContent = v;
    }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.card-add[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const card = btn.closest('.card');
    const variantId = card.querySelector('.size-pill.selected')?.getAttribute('data-variant-id')
      || card.querySelector('[data-default-variant]')?.getAttribute('data-default-variant')
      || btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const resp = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      });
      if (!resp.ok) throw new Error('add failed');
      await refreshCartDrawer();
      openCart();
    } catch (err) {
      console.error(err);
      btn.textContent = '+ Add to bag';
      alert('Sorry, something went wrong adding that. Try again?');
    } finally {
      btn.disabled = false;
      btn.textContent = '+ Add to bag';
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !form.hasAttribute('data-doja-add-form')) return;
    e.preventDefault();
    const fd = new FormData(form);
    const btn = form.querySelector('[type="submit"]');
    const original = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const resp = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      });
      if (!resp.ok) throw new Error('add failed');
      await refreshCartDrawer();
      openCart();
    } catch (err) {
      console.error(err);
      alert('Sorry, something went wrong adding that. Try again?');
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original || 'Add to bag'; }
    }
  });

  async function refreshCartDrawer() {
    try {
      const resp = await fetch(window.routes.cart_url + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } });
      if (!resp.ok) return;
      const html = await resp.text();
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      const fresh = wrap.querySelector('#cart-drawer');
      const current = document.getElementById('cart-drawer');
      if (fresh && current) {
        // Try a scoped swap (items + footer + title only) so we don't
        // destroy the delivery picker DOM — the picker controller takes
        // ~500ms to re-hydrate, making the whole drawer feel laggy.
        // Fall back to a full swap when the structure changes (empty ↔ items).
        const scoped = scopedDrawerSwap(current, fresh);
        if (!scoped) current.innerHTML = fresh.innerHTML;

        const count = fresh.getAttribute('data-cart-count');
        if (count != null) {
          current.setAttribute('data-cart-count', count);
          updateCartCount(count);
        }
      }
      document.dispatchEvent(new CustomEvent('doja:cart-updated'));
    } catch (e) {}
  }
  window.dojaRefreshCartDrawer = refreshCartDrawer;

  // Returns true when it managed an in-place swap of items + footer + title.
  // Returns false when the empty-state branch changed and the caller needs
  // to fall back to a full innerHTML swap.
  function scopedDrawerSwap(current, fresh) {
    const currentItems = current.querySelector('.cart-drawer__items');
    const freshItems   = fresh.querySelector('.cart-drawer__items');
    const currentFoot  = current.querySelector('.cart-drawer__foot');
    const freshFoot    = fresh.querySelector('.cart-drawer__foot');
    // Either side switching between "has items" and "empty" → bail out.
    if (!currentItems || !freshItems || !currentFoot || !freshFoot) return false;

    currentItems.replaceWith(freshItems);
    currentFoot.replaceWith(freshFoot);

    const currentTitle = current.querySelector('.cart-drawer__title');
    const freshTitle   = fresh.querySelector('.cart-drawer__title');
    if (currentTitle && freshTitle) currentTitle.textContent = freshTitle.textContent;
    return true;
  }

  function updateCartCount(count) {
    if (count == null) return;
    document.querySelectorAll('.cart-count').forEach((el) => {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  document.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    if (removeBtn.dataset.busy) return; // ignore repeat clicks while in-flight
    removeBtn.dataset.busy = '1';

    // We use the 1-based line index (not item.key) because the delivery
    // picker re-stamps line properties on every cart change, which mutates
    // the hashed line keys mid-flight and breaks {id: key, quantity: 0}.
    const line = parseInt(removeBtn.getAttribute('data-cart-remove'), 10);
    const row = removeBtn.closest('.cart-drawer__item');
    if (row) { row.style.opacity = '0.4'; row.style.pointerEvents = 'none'; }

    try {
      const resp = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      });
      if (!resp.ok) throw new Error('remove failed: ' + resp.status);
      await refreshCartDrawer();
    } catch (err) {
      console.error(err);
      if (row) { row.style.opacity = ''; row.style.pointerEvents = ''; }
      delete removeBtn.dataset.busy;
      alert('Sorry, that didn’t remove. Try again?');
    }
  });
  document.addEventListener('change', async (e) => {
    const qtyInput = e.target.closest('[data-cart-qty]');
    if (qtyInput) {
      const line = parseInt(qtyInput.getAttribute('data-cart-qty'), 10);
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      });
      await refreshCartDrawer();
    }
  });

  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.pdp-thumb');
    if (!thumb) return;
    const src = thumb.querySelector('img')?.getAttribute('data-full') || thumb.querySelector('img')?.src;
    const main = thumb.closest('.pdp-gallery')?.querySelector('.pdp-main-img img');
    if (src && main) main.src = src;
    thumb.closest('.pdp-thumbs')?.querySelectorAll('.pdp-thumb').forEach((t) => t.classList.remove('active'));
    thumb.classList.add('active');
  });

  document.addEventListener('click', (e) => {
    const q = e.target.closest('.faq-q');
    if (!q) return;
    e.preventDefault();
    const item = q.closest('.faq-item');
    if (!item) return;
    if (item.hasAttribute('open')) item.removeAttribute('open');
    else item.setAttribute('open', '');
  });
})();
